<template>
<div class="container text-center">
  <br>
  <div class="card">
    <div class="card-body">
      <!-- <h3 class="display-5">Business Connection Hub</h3><br> -->
      <h6 class="display-5">Browse Product Catalog</h6>
      <h6 class="display-5">Place Order Requests</h6>
      <h6 class="display-5">Receive and Send Messages</h6>
    </div>
  </div>

  <br><br>
  <!-- <h4>Directory</h4>
  <br> -->
  <a class="display-5 font-weight-bold" href="#" @click="goTo('Ketco')">Ketco - Krishna Electric & Trading Co.</a>
  <br><br>
  <a class="display-5 font-weight-bold" href="#" @click="goTo('Demo')">Demo</a>

  <br><br>


</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  components: {
  },

  data() {
    return {
    }
  },

  mounted(){
    this.setOrgId('')
    this.setOrgName('')
  },

  methods: {
    ...mapActions(['setOrgId', 'setOrgName']),

    goTo(orgId){
      this.$router.push({ name: 'mainpage', params: { orgId: orgId } })
    },
  }
}
</script>

<style scoped>

</style>
